import { snakeCaseToTitleCase } from '~/lib/cases';
const prepareClassifications = (anchor, comparatorDocs) => {
    let preppedData = {
        categories: ['Clauses', 'Dec Page Fields'],
        descriptors: [],
        tagsColumn: [],
    };
    preppedData = extractTags(anchor, preppedData);
    for (const doc of comparatorDocs) {
        preppedData = extractTags(doc, preppedData);
    }
    return preppedData;
};
const extractTags = (doc, preppedData) => {
    for (const catKey of Object.keys(doc.data)) {
        switch (catKey) {
            case 'clauses':
                preppedData = clauseTagExtractor(doc.data.clauses, preppedData);
                break;
            case 'decPageFields':
                preppedData = decPageTagExtractor(doc.data.decPageFields, preppedData);
                break;
            default:
                break;
        }
    }
    return preppedData;
};
const decPageTagExtractor = (decPageFields, preppedData) => {
    const catDataElement = { key: 'decPageFields', display: 'Dec Page Fields', subRows: [] };
    for (const decPageKey of Object.keys(decPageFields)) {
        const descDataElement = {
            key: decPageKey,
            display: snakeCaseToTitleCase(decPageKey),
            subRows: [],
        };
        if (!preppedData.descriptors.includes(descDataElement.display)) {
            preppedData.descriptors.push(descDataElement.display);
        }
        const tagIndex = preppedData.tagsColumn.findIndex(tc => tc.descriptor.key === decPageKey);
        if (tagIndex !== -1)
            continue;
        preppedData.tagsColumn.push({
            category: catDataElement,
            descriptor: descDataElement,
        });
    }
    return preppedData;
};
const clauseTagExtractor = (clauses, preppedData) => {
    const catDataElement = { key: 'clauses', display: 'Clauses', subRows: [] };
    for (const clauseKey of Object.keys(clauses)) {
        const descDataElement = {
            key: clauseKey,
            display: snakeCaseToTitleCase(clauseKey),
            subRows: [],
        };
        if (!preppedData.descriptors.includes(descDataElement.display)) {
            preppedData.descriptors.push(descDataElement.display);
        }
        const tagIndex = preppedData.tagsColumn.findIndex(tc => tc.descriptor.key === clauseKey);
        if (tagIndex !== -1)
            continue;
        if (clauses[clauseKey] && clauses[clauseKey].checklistItems) {
            for (const checklistQuestion of Object.keys(clauses[clauseKey].checklistItems)) {
                descDataElement.subRows.push({
                    category: { key: 'checklistItem', display: 'Checklist Item', subRows: [] },
                    descriptor: { key: checklistQuestion, display: checklistQuestion, subRows: [] },
                });
            }
        }
        preppedData.tagsColumn.push({
            category: catDataElement,
            descriptor: descDataElement,
        });
    }
    return preppedData;
};
export default prepareClassifications;
